module.exports = {
      id: "audio-pause-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#audio-pause",
      toString: function () {
        return this.url;
      }
    }